import { Dispatch, SetStateAction } from "react";

// Optional: Add return type
export interface BarClickParams {
  dataIndex: number;
  seriesId: string;
}

export interface HandleBarClickArgs {
  params: BarClickParams;
  series: { dataKey: string }[];
  setSelectedBarData: Dispatch<SetStateAction<any>>;
  setPopupOpen: Dispatch<SetStateAction<boolean>>;
  searchParams: URLSearchParams; // Optional, if you need to update search params
  section: string; // Optional, if you need to set a specific section
  setSearchParams: Dispatch<SetStateAction<URLSearchParams>>; // Optional, if you need to update search params
  queryID: string; // Optional, if you need to set a query ID
}

export const handleBarClickPopupforBars = ({
  params,
  series,
  setSelectedBarData,
  setPopupOpen,
  searchParams,
  section,
  setSearchParams,
  queryID,
}: HandleBarClickArgs) => {
  const { dataIndex, seriesId } = params || {};

  if (typeof dataIndex === "number" && typeof seriesId === "string") {
    const match = seriesId.match(/auto-generated-id-(\d+)/);
    const seriesIndex = match ? parseInt(match[1], 10) : -1;

    if (seriesIndex >= 0 && seriesIndex < series.length) {
      const source = series[seriesIndex].dataKey;

      const selectedData = {
        id: source,
        source: source,
      };

      // Set popup data
      setSelectedBarData(selectedData);
      setPopupOpen(true);
      const updatedParams = new URLSearchParams(searchParams);
      updatedParams.set("section", section);
      updatedParams.set("queryID", queryID);
      setSearchParams(updatedParams);
    }
  }
};
